<template>
    <div class="selected" data-selected-bar style="bottom: 0px">
        <div class="selected-header">
            <div class="container selected-header-content">
                <div class="selected-heading">
                    Wybrano:
                    <span>
                        {{
                            selectedGroups.length
                                | plurals('grupę', 'grupy', 'grup')
                        }}
                    </span>
                    <span>
                        ({{
                            promosCount
                                | plurals('promocję', 'promocje', 'promocji')
                        }})
                    </span>
                </div>
                <div class="selected-actions">
                    <the-btn
                        btn-class="btn-danger"
                        text="Wyczyść zaznaczone"
                        @click.native="deselectAll"
                    ></the-btn>
                    <the-btn
                        btn-class="btn-secondary"
                        text="Przejdź do aktywacji"
                        icon="Promotions"
                        @click.native="acceptPromos"
                    ></the-btn>
                </div>
                <div class="selected-actions-xs">
                    <the-btn
                        btn-class="btn-danger"
                        text="Wyczyść"
                        @click.native="deselectAll"
                    ></the-btn>
                    <the-btn
                        btn-class="btn-secondary"
                        text="Aktywuj"
                        icon="Promotions"
                        @click.native="acceptPromos"
                    ></the-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { tour } from '@/walkthroughs/promoAccept'
export default {
    props: {
        selectedGroups: {
            type: Array,
            required: true
        }
    },
    computed: {
        promosCount() {
            return this.selectedGroups.reduce((acc, group) => {
                return acc + group.selectedPromoIds.length
            }, 0)
        }
    },
    methods: {
        deselectAll() {
            this.$store.dispatch('setSelectAllPromotions', false)
            this.$store.dispatch('clearSelectedPromoGroups')
        },
        acceptPromos() {
            if (this.$store.getters.isLotteryUser) {
                this.$store.dispatch('onLotteryUserNoPermission')
            } else {
                this.$gtag.event('add_to_cart', {
                    items: this.selectedGroups.map(el => {
                        return {
                            name: el.name,
                            id: el.id.toString(),
                            list_name: 'Lista',
                            price: '1',
                            brand: 'Producent',
                            quantity: 1
                        }
                    })
                })
                this.$store.dispatch('openModal', {
                    component: 'ModalPromoAccept',
                    classes: 'modal--accept'
                })
                setTimeout(() => {
                    if (this.$store.getters.getWalkthroughActive) {
                        tour.show(9)
                    }
                }, 0)
            }
        }
    }
}
</script>
